<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-eye"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body custom-background">
    <div class="row">
      <div class="col-md-1 font-weight-bold">{{ "TITLE.ATTACHMENTS" | translate }}</div>
      <div
        class="col-md-11 font-weight-light custom-container-right-padding custom-div-words">
        <a href="javascript:" *ngFor="let resource of resourceList; let index=index"
           (click)="setUrlDoc(resource)">{{resource.fileName}}; </a>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-md-12" style="height: 500px">
        <div class="custom-height-full mt-2" *ngIf="!reloadingPdf">
          <ng2-pdfjs-viewer #pdfViewer
                            [pdfSrc]="urlStream"
                            [download]="false"
                            [print]="false"
                            [openFile]="false"
                            [showSpinner]="true"
                            [viewBookmark]="false"
                            scroll="V"
                            viewerId="documentVisor">
          </ng2-pdfjs-viewer>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
